import React, { useEffect } from "react";

import Button from "@mui/material/Button";
import { ReactComponent as OnelinkToInfoGraphic } from "assets/images/onelinkto.svg";

import { getLanguageString as _ } from "misc/lang";
import css from "./landingpage.module.scss";
import { DefaultProps } from "model/props";
import { Pages } from "appConfig";

export interface Props extends DefaultProps {
  inBackground?: boolean;
}

const LandingPage: React.FC<Props> = (props) => {
  const { user, navigate, inBackground } = props;

  useEffect(() => {
    if (!inBackground) {
      window.history.pushState("url-rewrite", document.title, "/");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className={css.landingpage}>
      <div className={css.page}>
        <div className={css.pageContentWrapper}>
          <h1 className={css.tagline}>
            Simplify app downloads <br />
            with <span>onelink.to</span> all app stores
          </h1>
        </div>
        {!user && (
          <div className={css.pageContentWrapper}>
            <div className={css.actions}>
              <Button
                className={css.topMenuButton}
                component="span"
                onClick={() => navigate(Pages.REGISTER)}
                variant="contained"
                color="primary"
                size="large"
              >
                {_("general", "signup_now_free_free")}
              </Button>
            </div>
          </div>
        )}

        <div className={css.pageContentWrapper}>
          <div className={css.info}>
            With <span className={css.onelinkto}>onelink.to</span> you get one
            short link or QR code to your app no matter if it's on
            <span className={css.appstore}> Apple AppStore</span>,
            <span className={css.appstore}> Google Play</span>,
            <span className={css.appstore}> Huawei AppGallery</span>,
            <span className={css.appstore}> Microsoft Store</span> and many
            more.
            <br />
            <br />
            Instead of printing several QR codes or having several separate
            links to each app store, you only need one short link or QR code.
            Works on iPhone, iPad, Android, Windows Phone, and many more.
          </div>
        </div>

        <div className={css.pageContentWrapper}>
          <div className={css.graphics}>
            <div className={css.imageWrapper}>
              {/* <img
                className={css.image}
                id="graphic-bg"
                alt="onelink"
                src={OnelinkToInfoGraphic}
              /> */}
              <OnelinkToInfoGraphic className={css.image} />
            </div>
          </div>
        </div>

        <div className={css.pageContentWrapper} style={{ flexGrow: 4 }}></div>
      </div>
    </div>
  );
};

export default LandingPage;
